import React from 'react';
import { render } from 'react-dom';
import LureBuilder from './components/lurebuilder';

const App = () => (
    <>
        <div className="notifications" id="dialog-notifications-error" title="error" style={{ display: 'none' }}></div>
        <div id="bar-notification" className="notifications" style={{ display: 'none' }}>
            <span className="close" title="success"><span className="fa fa-close"></span></span>
        </div>
        <LureBuilder />
    </>
);

render(<App />, document.getElementById("App"));